import React, { useEffect, useRef, useState } from 'react';
import { Button, Popup, ScrollView } from 'devextreme-react';
import Form, { RequiredRule, GroupItem, Label, SimpleItem, AsyncRule, EmptyItem, StringLengthRule } from 'devextreme-react/form';
import { useDispatch, useSelector } from 'react-redux';
import { categoriesDataSource, dataAccess, editorOptionsNumberBox, editorOptsTextBoxPhone, formatDate, getPriceByCategory, resources } from '../../data/app';
import { registerDialog } from '../../store/register/registerReducer';
import http from '../../utils/http';
import { createStore, createStoreLocal } from '../../utils/proxy';
import uri from '../../utils/uri';
import { dataDefault } from '../../data/defaultObject';
import notify from 'devextreme/ui/notify';
import useTypeLicences from '../../hooks/useTypeLicences';
import useAuthorization from '../../hooks/useAuthorization';
import { on } from 'devextreme/events';

const Nuevo = props => {

    const { authorized, auth } = useAuthorization([resources.matriculas, dataAccess.create]);

    const dispatch = useDispatch();
    const { user, register: { open, id }, appInfo } = useSelector(store => store);

    const prefix = user.areaId == 1 ? 'B' : 'A';

    const refForm = useRef();

    const [data, setData] = useState({ ...dataDefault });
    const { typeLicences } = useTypeLicences();

    const [saving, setSaving] = useState({
        text: 'Guardar',
        loading: false
    });

    const closeDialog = (load) => {
        dispatch(registerDialog({ open: false, id: 0 }));

        if (load) {

            let { onSave } = props;
            onSave();

        }
    }

    const onHiding = ({ load }) => closeDialog(load);

    const save = e => {

        let resultValidate = refForm.current.instance.validate();

        resultValidate.complete.then(result => {

            if (result.isValid) {

                setSaving({ loading: true, text: 'Guardando...' });
                let newData = { ...data };

                newData.reference = (newData.reference === '' || newData.reference === null) ? '' : prefix + '-' + newData.reference;

                http(uri.registers.insert).asPost(newData).then(resp => {

                    setSaving({ loading: false, text: 'Guardar' });
                    notify(`Matricula registrada correctamente`);
                    closeDialog(true);

                }).catch(err => {

                    setSaving({ loading: false, text: 'Guardar' });
                    notify(err, 'error', 5000);

                });

            }

        });

    }

    useEffect(() => {

        if (id > 0) {

            http(uri.registers.getById(id)).asGet().then(resp => {

            });

        } else
            setData({
                ...dataDefault,
                subTotal: 0,
                total: 0,
                balance: 0
            });

    }, [open]);

    const validationCallback = (e) => {
        return new Promise(resolve => {
            resolve((data.initBalance > 0 && data.reference != '') || (data.initBalance == 0 && data.reference == ''));
        });
    }

    const isNew = id === 0;

    return authorized(
        <div>
            <Popup
                width={700}
                height={800}
                title={`Nueva matricula`}
                onHiding={onHiding}
                visible={open}
                className="bg-fbfbfb"
            >
                <ScrollView showScrollbar='never' >
                    <Form formData={data} ref={refForm}
                    // onFieldDataChanged={e => {
                    // if (e.dataField === "categories") {
                    //     const categories = e.value || [];
                    //     let form = refForm.current.instance;

                    //     console.log({categories});

                    //     form.option('subTotal', 100);
                    //     form.repaint();

                    //     // setData(prev => {
                    //     //     if (categories.includes(1) && categories.includes(2) && categories.includes(3)) {
                    //     //     return { ...prev, subTotal: appInfo.price };
                    //     //     } else if (categories.includes(1) && categories.includes(2)) {
                    //     //     return { ...prev, subTotal: appInfo.price2 };
                    //     //     } else if (categories.includes(3)) {
                    //     //     return { ...prev, subTotal: appInfo.price3 };
                    //     //     }
                    //     //     return { ...prev, subTotal: 0 };
                    //     // });
                    // }
                    >

                        <GroupItem colCount={6}>
                            <SimpleItem dataField="name" colSpan={6}>
                                <Label text="Nombre" />
                                <RequiredRule message="Ingrese el nombre" />
                            </SimpleItem>
                            <SimpleItem dataField="identification" colSpan={3}>
                                <Label text="Cédula" />
                                <StringLengthRule max={20} message="Maximo de carateres permitidos 20" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>
                            <SimpleItem dataField="phoneNumber" colSpan={3} editorOptions={{ ...editorOptsTextBoxPhone }}>
                                <Label text="Telefono" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>
                            <SimpleItem dataField="age" colSpan={3} editorOptions={{ ...editorOptionsNumberBox }} editorType="dxNumberBox">
                                <Label text="Edad" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>
                            <SimpleItem dataField="countryCode" colSpan={3} editorType="dxSelectBox" editorOptions={{
                                dataSource: createStore({ name: 'Country' })
                                , displayExpr: "name"
                                , valueExpr: "code"
                            }}>
                                <Label text="Nacionalidad" />
                                <RequiredRule message="Seleccione la nacionalidad" />
                            </SimpleItem>
                            <SimpleItem dataField="schoolLevel" colSpan={3} editorType="dxSelectBox" editorOptions={{
                                dataSource: createStore({ name: 'SchoolLevel' })
                                , displayExpr: "name"
                                , valueExpr: "id"
                            }}>
                                <Label text="Nivel Escolar" />
                                <RequiredRule message="Seleccione Nivel Escolar" />
                            </SimpleItem>

                            <EmptyItem colSpan={3} />

                            <SimpleItem dataField="address" colSpan={6} editorType="dxTextBox">
                                <StringLengthRule max={250} message="Maximo de carateres permitidos 250" />
                                <Label text="Direccion" />
                            </SimpleItem>

                        </GroupItem>
                        <GroupItem colCount={6} caption="Datos de la matricula">
                            <SimpleItem dataField="categories" colSpan={3} editorType="dxTagBox" editorOptions={{
                                dataSource: categoriesDataSource,
                                showSelectionControls: true,
                                onValueChanged: e => {
                                    const categories = e.value || [];

                                    const newSubTotal = getPriceByCategory(appInfo, categories);                               

                                    setData(prev => {
                                        if (prev.subTotal === newSubTotal) return prev; // 🔑 evita loop
                                        return { ...prev, subTotal: newSubTotal, total: newSubTotal, balance: newSubTotal - prev.initBalance };
                                    });
                                }
                            }}>
                                <Label text="Categorias" />
                                <RequiredRule message="Seleccione una categoria" />
                            </SimpleItem>
                            <EmptyItem colSpan={3} />
                            <SimpleItem dataField="startDate" colSpan={3} editorType="dxDateBox"
                                editorOptions={{ displayFormat: formatDate, openOnFieldClick: true }}>
                                <Label text="Fecha Inicio" />
                                <RequiredRule message="Seleccione la fecha de inicio" />
                            </SimpleItem>
                            <SimpleItem dataField="subTotal" colSpan={3} editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox, disabled: true }}>
                                <Label text="Precio" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>
                            {/* <SimpleItem dataField="discount" colSpan={3} editorType="dxNumberBox"
                                editorOptions={{
                                    ...editorOptionsNumberBox,
                                    onValueChanged: e => {
                                        let discount = e.value;

                                        if(discount < 0)
                                            discount = 0;

                                        const total = data.subTotal - discount ;
                                        const balance = total - data.initBalance;
                                        setData({ ...data, total: total,balance: balance, discount });
                                    }
                                }}>
                                <Label text="Descuento" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>
                            <SimpleItem dataField="total" colSpan={3} editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox, disabled: true }}>
                                <Label text="Total" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem> */}
                            <SimpleItem dataField="initBalance" colSpan={3} editorType="dxNumberBox"
                                editorOptions={{
                                    ...editorOptionsNumberBox,
                                    onValueChanged: e => {

                                        let initBalance = e.value;

                                        if (initBalance < 0)
                                            initBalance = 0;

                                        const balance = data.total - initBalance;
                                        setData(prev => ({ ...prev, balance: balance, initBalance }));

                                    }
                                }}>
                                <Label text="Abono inicial" />
                            </SimpleItem>
                            <SimpleItem dataField="balance" colSpan={3} editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox, disabled: true }}>
                                <Label text="Pendiente" />
                            </SimpleItem>
                            <SimpleItem dataField="reference" editorType="dxNumberBox" colSpan={3} editorOptions={{
                                format: prefix + " ###",
                                placeholder: prefix + '0000'
                            }}>
                                <Label text="No Recibo" />
                                <AsyncRule message="Ingrese el recibo" validationCallback={validationCallback}></AsyncRule>
                            </SimpleItem>
                            <SimpleItem dataField="paymentTypeId" colSpan={3} editorType="dxSelectBox" editorOptions={{
                                dataSource: createStore({ name: 'paymentType' })
                                , displayExpr: "name"
                                , valueExpr: "id"
                            }}>
                                <Label text="Tipo Pago" />
                                <RequiredRule message="Seleccione el tipo de pago" />
                            </SimpleItem>
                            <SimpleItem dataField="conceptId" colSpan={3} editorType="dxSelectBox" editorOptions={{
                                dataSource: createStore({ name: 'Concept' })
                                , displayExpr: "name"
                                , valueExpr: "id"
                            }}>
                                <Label text="Concepto" />
                                <RequiredRule message="Seleccione el concepto" />
                            </SimpleItem>
                            <SimpleItem dataField="typeLicenceId" colSpan={3} editorType="dxRadioGroup" editorOptions={{
                                dataSource: typeLicences,
                                displayExpr: 'name',
                                valueExpr: 'id',
                            }}>
                                <Label text="Tipo" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>


                            <SimpleItem dataField="instructorId" colSpan={3} editorType="dxSelectBox" editorOptions={{
                                dataSource: createStoreLocal({ name: 'Instructor', active: isNew })
                                , displayExpr: "name"
                                , valueExpr: "id"
                            }}>
                                <Label text="Instructor" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>

                            <SimpleItem dataField="courseType" colSpan={3} editorType="dxSelectBox" editorOptions={{
                                dataSource: createStore({ name: 'CourseType' })
                                , displayExpr: "name"
                                , valueExpr: "id"
                            }}>
                                <Label text="Tipo de curso" />
                                <RequiredRule message="Seleccione Tipo de curso" />
                            </SimpleItem>

                            <SimpleItem dataField="theoreticalHours" colSpan={3} editorOptions={{ ...editorOptionsNumberBox }} editorType="dxNumberBox">
                                <Label text="Horas Teoricas" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>

                            <SimpleItem dataField="practicalHours" colSpan={3} editorOptions={{ ...editorOptionsNumberBox }} editorType="dxNumberBox">
                                <Label text="Horas Practicas" />
                                <RequiredRule message="Complete este campo" />
                            </SimpleItem>

                            <SimpleItem dataField="observation" colSpan={6} editorType="dxTextBox">
                                <StringLengthRule max={250} message="Maximo de carateres permitidos 250" />
                                <Label text="Observacion" />
                            </SimpleItem>
                        </GroupItem>
                    </Form>

                    <Button
                        width={180}
                        text={saving.text}
                        disabled={saving.loading}
                        type="default"
                        icon='save'
                        onClick={save}
                    />
                </ScrollView>
            </Popup>
        </div>
    );
}

export default Nuevo;
